import { useState } from 'react'
import { Control, Controller } from 'react-hook-form'
import { Checkbox } from 'antd'
import { IDistributedScale, IDistributedScaleAnswer } from '@/models'
import { Scale, Text } from '@/components/ui'

interface IDistributedScaleProps {
  question: IDistributedScale
  control: Control
  getValues: () => number[]
  setValue: () => void
}

const DistributedScale = ({ question, control, getValues, setValue }: IDistributedScaleProps) => {
  const [pointsLeft, setPointsLeft] = useState<number>(question.balli)

  const getPointsLeft = () => {
    const totalSelectedPoints = Object.values(getValues()[question.id] || {})?.reduce(
      (a: number, b: any) => (a || 0) + (b || 0),
      0
    )
    setPointsLeft(question.balli - totalSelectedPoints)
  }

  const getValue = (uuid: string, value: number) => {
    const answers = Object.entries(getValues()[question.id] || [])
    let sum = 0
    answers.forEach((v: any) => {
      if (v[0] !== uuid && v[1] && v[1] <= question.max_score_per_option) sum += v[1]
    })
    const answerFreePoints: number = question.balli - sum
    if (value <= answerFreePoints) {
      return true
    }
    return false
  }

  return (
    <>
      <Text style={{ height: 18 }} as='div' size='md' color='gray-dark'>
        Распределите {pointsLeft} баллов из {question.balli}
      </Text>
      {question?.answers?.map((scale: IDistributedScaleAnswer) =>
        scale?.title !== 'Затрудняюсь ответить' && scale?.code !== 99 ? (
          <div key={`div-${scale.uuid}`} className='offset-top-20'>
            <Controller
              key={scale.uuid}
              name={`${question.id}.${scale.uuid}`}
              control={control}
              render={({ field: { name, value, onChange } }) => (
                <Scale
                  name={name}
                  value={value ?? 0}
                  onChange={(value) => {
                    if (getValue(scale.uuid, value)) {
                      onChange(value)
                      getPointsLeft()
                    }
                  }}
                  count={question?.max_score_per_option > 0 ? question.max_score_per_option : question.balli}
                  prefix={scale.title}
                  suffix={
                    question?.max_score_per_option > 0
                      ? question.max_score_per_option.toString()
                      : question.balli.toString()
                  }
                  style={{ background: scale.color }}
                />
              )}
            />
          </div>
        ) : (
          <Controller
            name={`${question.id}.${scale.uuid}`}
            key={scale.uuid}
            control={control}
            render={({ field }) => (
              <Checkbox
                {...field}
                checked={field.value === 99}
                prefixCls='checkbox-scale'
                onChange={(e) => {
                  if (e.target.checked) {
                    question?.answers?.forEach((a: any) => {
                      if (a.uuid !== scale.uuid) setValue(`${question.id}.${a.uuid}`, undefined)
                      setValue(`${question.id}.${scale.uuid}`, 99)
                    })
                  } else {
                    setValue(`${question.id}.${scale.uuid}`, undefined)
                  }
                }}
                className='offset-top-30'
              >
                Затрудняюсь ответить
              </Checkbox>
            )}
          />
        )
      )}
    </>
  )
}

export default DistributedScale
